import type { CSSProperties } from "react";

/** Reusable `style` props for `react-perfect-scrollbar` panes (stable object identity). */
export const PERFECT_SCROLLBAR_MAX_88: CSSProperties = { maxHeight: 88 };
export const PERFECT_SCROLLBAR_MAX_96: CSSProperties = { maxHeight: 96 };
export const PERFECT_SCROLLBAR_MAX_100: CSSProperties = { maxHeight: 100 };
export const PERFECT_SCROLLBAR_MAX_220: CSSProperties = { maxHeight: 220 };
export const PERFECT_SCROLLBAR_MAX_240: CSSProperties = { maxHeight: 240 };
export const PERFECT_SCROLLBAR_MAX_280: CSSProperties = { maxHeight: 280 };
export const PERFECT_SCROLLBAR_MAX_300: CSSProperties = { maxHeight: 300 };
export const PERFECT_SCROLLBAR_MAX_320: CSSProperties = { maxHeight: 320 };
export const PERFECT_SCROLLBAR_MAX_340: CSSProperties = { maxHeight: 340 };
export const PERFECT_SCROLLBAR_MAX_360: CSSProperties = { maxHeight: 360 };
export const PERFECT_SCROLLBAR_MAX_420: CSSProperties = { maxHeight: 420 };
